import Http from './http'

function serialize(obj) {
	const str = []

	for (const key in obj) {
		if (Array.isArray(obj[key])) {
			// Append [] so PHP/Laravel parses repeated keys as an array,
			// not a single scalar (otherwise `array` validation rules fail).
			obj[key].forEach(val => {
				str.push(`${encodeURIComponent(`${key}[]`)}=${encodeURIComponent(val)}`)
			})
		} else if (obj[key] !== undefined && obj[key] !== null) {
			str.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
		}
	}

	return str.length ? `?${str.join('&')}` : ''
}

// NEWSLETTER
export const newsletters = (params = '') => Http.get(`/newsletters${serialize(params)}`)
export const deleteNewsletter = (params = '') => Http.delete(`/newsletters/${params.id}`)
export const newsletterCreate = (params = '') => Http.post('/newsletters', params)
export const newsletterByID = (params = '') => Http.get(`/newsletters/${params}`)
export const newsletterUpdate = (params = '') => Http.put(`/newsletters/${params.id}`, params)
export const newsletterDuplicates = (params = {}) => Http.post('/newsletters/duplicates', params)
export const newsletterBulkDelete = (ids = []) => Http.post('/newsletters/bulk-delete', { ids })
export const newsletterDedupPreview = (params = {}) => Http.post('/newsletters/dedup/preview', params)
export const newsletterDedupRun = (params = {}) => Http.post('/newsletters/dedup/run', params)
